module.exports = __webpack_public_path__ + "media/images/woman-in-video-with-party-poppers-7fd59a412469603646dd0869bd5045fa.png";